export default __webpack_public_path__ + "static/media/add_from_google_sheet_icon.5aa72e7d.svg";